<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_404_3532)">
            <circle cx="8" cy="7.99996" r="6" stroke="#DD2039" stroke-linecap="round" stroke-linejoin="round" />
            <rect x="8" y="10.6667" width="0.00666714" height="0.00666618" stroke="#DD2039" stroke-width="1.5"
                stroke-linejoin="round" />
            <path d="M8 8L8 5.33333" stroke="#DD2039" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_404_3532">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>

</template>